import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Card,
    Descriptions,
    Button,
    Input,
    Row,
    Col,
    Form,
    Space,
    notification,
    InputNumber
} from 'antd';
import { updateFinancialInfo } from '../../util/APIUtils';

// This is for the read-only display view
const percentageFormatter = (value) => {
    if (value === null || value === undefined) return '';
    const germanDecimal = String(value).replace('.', ',');
    return `${germanDecimal} %`;
};

// --- New Helpers for the InputNumber component ---

// Formats the number in the input to use a comma for the decimal place
const germanDecimalFormatter = (value) => {
    if (value === null || value === undefined) return '';
    return String(value).replace('.', ',');
};

// Parses the comma-decimal string from the input back to a standard number
const germanDecimalParser = (value) => {
    if (value === null || value === undefined) return null;
    const standardDecimal = String(value).replace(',', '.').trim();
    // Allow empty input
    if (standardDecimal === '') return null;
    return Number(standardDecimal);
};

function FinancialInfo(props) {
    const { financialInfo, breederId, loadBreederInfo } = props;
    const [loading, setLoading] = useState(false);
    const [editing, setEditing] = useState(false);
    const [form] = Form.useForm();
    const { t } = useTranslation();

    // Effect to reset form fields when data changes or editing is cancelled
    useEffect(() => {
        if (financialInfo) {
            form.setFieldsValue({
                bank: financialInfo.bank,
                bic: financialInfo.bic,
                iban: financialInfo.iban,
                ktonr: financialInfo.ktonr,
                taxNumber: financialInfo.taxNumber,
                ust: financialInfo.ust,
                ustHint: financialInfo.ustHint,
                ustId: financialInfo.ustId,
            });
        }
    }, [financialInfo, form]);

    const onFinish = async (values) => {
        setLoading(true);
        const financialData = {
            breederId: breederId,
            ...values
        };

        try {
            await updateFinancialInfo(financialData);
            setLoading(false);
            setEditing(false);
            notification.success({ message: "Kultursaat", description: "Finanzinformationen erfolgreich gespeichert.", placement: 'topLeft' });
            // Reload the parent component's data
            if (loadBreederInfo) {
                loadBreederInfo();
            }
        } catch (error) {
            setLoading(false);
            console.error(error);
            notification.error({ message: "Kultursaat", description: "Speichern fehlgeschlagen.", placement: 'topLeft' });
        }
    };

    const handleCancel = () => {
        setEditing(false);
        // Reset form to initial values when cancelling
        form.resetFields();
    };

    return (
        <div>
            <Form form={form} onFinish={onFinish} initialValues={financialInfo}>
                <Descriptions
                    title={t("Finanzinformationen")}
                    bordered
                    size="small"
                    column={2}
                    extra={
                        !editing ? (
                            <Button onClick={() => setEditing(true)}>Bearbeiten</Button>
                        ) : (
                            <Space>
                                <Button type='primary' onClick={() => form.submit()} loading={loading}>Speichern</Button>
                                <Button onClick={handleCancel}>Abbrechen</Button>
                            </Space>
                        )
                    }
                    style={{ marginBottom: 20 }}
                >
                    <Descriptions.Item label="Kreditinstitut">
                        {editing ? <Form.Item name="bank"><Input /></Form.Item> : financialInfo?.bank}
                    </Descriptions.Item>
                    <Descriptions.Item label="BIC">
                        {editing ? <Form.Item name="bic"><Input /></Form.Item> : financialInfo?.bic}
                    </Descriptions.Item>
                    <Descriptions.Item label="IBAN">
                        {editing ? <Form.Item name="iban"><Input /></Form.Item> : financialInfo?.iban}
                    </Descriptions.Item>
                    <Descriptions.Item label="Konto">
                        {editing ? <Form.Item name="ktonr"><Input /></Form.Item> : financialInfo?.ktonr}
                    </Descriptions.Item>
                    <Descriptions.Item label="Steuernummer/USt-IdNr.">
                        {editing ? <Form.Item name="taxNumber"><Input /></Form.Item> : financialInfo?.taxNumber}
                    </Descriptions.Item>
                    {/* <Descriptions.Item label="USt-ID">
                        {editing ? <Form.Item name="ustId"><Input /></Form.Item> : financialInfo?.ustId}
                    </Descriptions.Item> */}
                   <Descriptions.Item label="USt.-Satz">
                       {editing ? (
                           <Form.Item name="ust">
                               <InputNumber
                                   formatter={germanDecimalFormatter}
                                   parser={germanDecimalParser}
                                   addonAfter="%"
                                   style={{ width: '100%' }}
                               />
                           </Form.Item>
                       ) : (
                           // The display view remains the same and looks great
                           percentageFormatter(financialInfo?.ust)
                       )}
                   </Descriptions.Item>
                    <Descriptions.Item label="Steuergrund">
                        {editing ? <Form.Item name="ustHint"><Input.TextArea autoSize={{ minRows: 1, maxRows: 3 }} /></Form.Item> : financialInfo?.ustHint}
                    </Descriptions.Item>
                </Descriptions>
            </Form>
        </div>
    );
}

export default FinancialInfo;